import { useEffect, useRef } from 'react';

type UseBrowserAgentOptions = {
    applicationID?: string;
};

// Global flag to ensure BrowserAgent is only initialized once across all instances
let isBrowserAgentInitialized = false;

// Export reset function for testing purposes
export const resetBrowserAgentInitialized = () => {
    isBrowserAgentInitialized = false;
};

const useBrowserAgent = (options?: UseBrowserAgentOptions) => {
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (typeof window === 'undefined' || hasInitialized.current || isBrowserAgentInitialized) {
            return;
        }

        const applicationID = options?.applicationID || process.env.NEWRELIC_BROWSER_APPID;
        if (!applicationID) {
            return;
        }

        hasInitialized.current = true;
        isBrowserAgentInitialized = true;

        (async () => {
            try {
                const { BrowserAgent } =
                    await import('@newrelic/browser-agent/loaders/browser-agent');

                const newRelicAgentOptions = {
                    init: {
                        distributed_tracing: { enabled: true },
                        privacy: { cookies_enabled: true },
                        ajax: { deny_list: ['bam.nr-data.net'] },
                    },
                    info: {
                        beacon: 'bam.nr-data.net',
                        errorBeacon: 'bam.nr-data.net',
                        licenseKey: 'NRJS-b5dcb3a7b0855a31fdd',
                        applicationID,
                        sa: 1,
                    },
                    loader_config: {
                        accountID: '2936348',
                        trustKey: '2321606',
                        agentID: '1103334436',
                        licenseKey: 'NRJS-b5dcb3a7b0855a31fdd',
                        applicationID,
                    },
                };

                new BrowserAgent(newRelicAgentOptions);
            } catch (error) {
                console.error('Error loading New Relic Browser Agent', error);
                // Reset flags on error so it can be retried
                hasInitialized.current = false;
                isBrowserAgentInitialized = false;
            }
        })();
    }, [options?.applicationID]);
};

export default useBrowserAgent;
